import React from 'react';
import ReactDOM from 'react-dom';
import Modal from '../ui/Modal';
const modalRoot = document.getElementById('modal-root') || document.body;
export const createModal = (options) => {
  const {
    closable = false,
    mask_close = false,
    className = "",
    component,
    alert = false,
    refElement = false,
    title = "",
    offset = [0, 0],
    zIndex = "1001",
    align = "top",
    frame = false,
    callback = () => { },
  } = options

  const div = document.createElement('div');
  if (refElement) {
    refElement.style.position = 'relative';
    refElement.style.zIndex = zIndex;
    refElement.parentNode.insertBefore(div, refElement.nextSibling);
  } else {
    modalRoot.appendChild(div);
  }

  const closeModal = (e) => {
    callback(e);
    if (modalRoot.contains(div)) {
      ReactDOM.unmountComponentAtNode(div);
      if (refElement) {
        refElement.style.position = '';
        refElement.style.zIndex = '';
        if (div.parentNode) {
          ReactDOM.unmountComponentAtNode(div);
          div.parentNode.removeChild(div);
        }
      } else {
        modalRoot.removeChild(div);
      }

    }
  };




  ReactDOM.render(<Modal frame={frame} mask_close={mask_close} align={align} className={className} offset={offset} alert={alert} refElement={refElement} closable={closable} title={title} callback={closeModal} component={component} />, div);
};
